module.exports = __webpack_public_path__ + "img/ABC.75983cf5.png";